var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"form-error type--sans type--s"},[_c('transition',{attrs:{"name":"fade-quick"}},[(_vm.props.error)?_c('div',{staticClass:"form-error__message"},[_vm._v(_vm._s(_vm.props.message))]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }